import { useEffect } from 'react';
import { useSetAtom } from 'jotai';

import { updateNavPathAtom } from '../stores/navPathAtoms';
import { setNavLabel } from '../utils/navPath';

/**
 * 화면 이름을 알린다. 여기로 돌아오는 목록 버튼이 쓴다.
 * `location` 은 이름과 같은 데이터에서 만든 주소여야 id 가 바뀔 때 이전 이름이 붙지 않는다.
 */
export function useNavigationPathLabel(
  location: string,
  label: string | undefined,
) {
  const updateNavPath = useSetAtom(updateNavPathAtom);

  useEffect(() => {
    if (!label) return;
    updateNavPath(prev => setNavLabel(prev, location, label));
  }, [updateNavPath, location, label]);
}
